module.exports = __webpack_public_path__ + "static/media/saba-sport.b728f262.png";